import {
  BorderProps,
  ButtonProps,
  TextProps,
} from 'spindl-shared-components';
import { TeamCardProps } from '../TeamCard';

type DeleteInviteModalInternalProps = {
  title?: TextProps;
  closeButton?: ButtonProps;
  border?: BorderProps;
  message?: TextProps;
  teamCard?: TeamCardProps;
  deleteButton?: ButtonProps;
  cancelButton?: ButtonProps;
};

type DeleteInviteModalPropsValues = {
  '': DeleteInviteModalInternalProps;
};

const propValues: DeleteInviteModalPropsValues = {
  '': {
    title: {
      align: 'Left',
      styleType: 'SemiBold',
      colour: 'Default',
      type: 'Heading5',
    },
    closeButton: {
      type: 'Icon',
      size: 'Small',
      styleType: 'PrimaryGhost',
      state: 'Default',
    },
    border: {
      colour: 'SubduedLight',
      type: 'Horizontal',
      styleType: 'Default',
    },
    message: {
      align: 'Center',
      styleType: 'Regular',
      colour: 'Default',
      type: 'Body1',
    },
    teamCard: {
      state: 'Pending',
      type: 'NoButton',
    },
    deleteButton: {
      type: 'Text',
      size: 'Medium',
      styleType: 'Destructive',
      state: 'Default',
    },
    cancelButton: {
      type: 'Text',
      size: 'Medium',
      styleType: 'PrimarySubdued',
      state: 'Default',
    },
  },
};

const getProps = (type: string): DeleteInviteModalInternalProps => {
  const values: DeleteInviteModalInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
